export const Loader = () =>  {

    return(
        <div className="overlay">
            <div className="spinner"></div>
        </div>
    );
}
